import type {LoginResult} from '@/types/member'
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {getInfo} from '@/services/login'


export const useAuthStore = defineStore(
    'auth', {
        state: () => ({
            token: uni.getStorageSync('token') || null,
        }),
        actions: {
            setToken(newToken: string | null) {
                this.token = newToken;
                if (newToken) {
                    uni.setStorageSync('token', newToken);
                    //localStorage.setItem('token', newToken);
                } else {
                    uni.removeStorageSync('token');
                    //localStorage.removeItem('token');
                }
            },

            clearToken() {
                this.setToken(null);
            },
            // 获取token接口
            async login() {
                try {
                    uni.request({
                        url: apiUrl + '/app/test/token',
                        method: 'POST',
                        success: (res) => {
                            uni.request({
                                url: apiUrl + '/app/open/api/h5/login',
                                data: {
                                    clientId: JSON.parse(res.data.data)?.clientId,
                                    param: JSON.parse(res.data.data)?.param
                                },
                                method: 'POST',
                                success: (resToken) => {
                                    const token = resToken.data.data?.token;
                                    // // 存储token和更新登录状态
                                    this.setToken(token)
                                }
                            });
                        }
                    });

                } catch (error) {
                    // 处理登录错误
                    console.error('Login error:', error);
                    // 可以根据错误类型显示相应的错误信息给用户
                }
            },
        },
    });

export const useMemberStore = defineStore(
    'userLevel',
    () => {
        // 会员信息
        const userLevel = ref()
        const isMember = ref(false)
        const infoState = ref(false)
        const clientType = ref<'direct' | "channel">('direct')
        const nextFuncList = ref<(() => any)[]>([])

        // 保存会员信息，登录时使用
        const setUserLevel = async () => {
            infoState.value = false
            const val = await getInfo()
            userLevel.value = val.data

            //clientType.value = val.data.thirdUserId
            // localStorage.setItem('userLevel', userLevel.value);
            isMember.value = (userLevel.value.userLevel === '1' || userLevel.value.userLevel === '2' || userLevel.value.userLevel === '3')
            infoState.value = true
            clientType.value = !!val.data.thirdUserId ? 'channel' : "direct"

            nextFuncList.value.forEach(f => f())
            nextFuncList.value = []
        }

        const setNextFunc = (f: () => any) => {
            if (infoState.value) {
                f()
                nextFuncList.value.forEach(f => f())
                nextFuncList.value = []
            } else {
                nextFuncList.value.push(f)
            }
        }


        // 清理会员信息，退出时使用
        const clearUserLevel = () => {
            uni.removeStorageSync('userLevel')
            //localStorage.removeItem('userLevel');
        }

        // 记得 return
        return {
            isMember,
            userLevel,
            clientType,
            setUserLevel,
            clearUserLevel,
            setNextFunc
        }
    },
    {
        // 网页端配置
        // persist: true,
        // 小程序端配置
        persist: {
            storage: {
                getItem(key) {
                    /*if (key !== 'nextFuncList') {
                        return uni.getStorageSync(key)
                    }*/
                    return uni.getStorageSync(key)
                },
                setItem(key, value) {
                    /*if (key !== 'nextFuncList') {
                        uni.setStorageSync(key, value)
                    }*/
                    uni.setStorageSync(key, value)
                },
            },
        },
    },
)
